module.exports = __webpack_public_path__ + "img/device.80f72365.svg";